import React, { useState } from "react";
import "./testimonial.css";
import Fade from "react-reveal/Fade";
import Bounce from "react-reveal/Bounce";
import Image1 from "../../Image/products/faro44.jpg";
import Image2 from "../../Image/products/faro59.jpg";
import Image3 from "../../Image/products/faro60.jpg";
import Image4 from "../../Image/products/faro61.jpg";
import Image5 from "../../Image/products/faro63.jpg";
import Image6 from "../../Image/products/faro64.jpg";
import Image7 from "../../Image/products/faro66.jpg";
import Image8 from "../../Image/products/faro67.jpg";
import Image9 from "../../Image/products/upia3.jpg";
import Image10 from "../../Image/products/ifehybrid6.jpg";
import Image11 from "../../Image/products/sammaz50.jpg";
import Image12 from "../../Image/products/tgx1448.jpg";
import Image13 from "../../Image/products/tgx1835.jpg";
import Image14 from "../../Image/products/tgx1951.jpg";

const Testimonial = () => {
  const data = [
    {
      img: Image1,

      content:
        "Medium maturing (100 - 110 days), long grain, high yield potential, optimum production under low management",
      name: "FARO 44",
      position: "Rice Variety",
    },

    {
      img: Image2,

      content:
        "Early-maturing (95 - 100 days), upland rice, golden grain colour, weed competitiveness and tolerance to lodging. Yield of 5 tonnes per hectare",
      name: "FARO 59",
      position: "Rice Variety",
    },
    {
      img: Image3,

      content:
        "Late maturing (120 - 130 days), high yielding, long and slender grain and tolerant to iron toxicity. Yield of 8 tonnes per hectare",
      name: "FARO 60",
      position: "Rice Variety",
    },
    {
      img: Image4,

      content:
        "Early-maturing (95 - 100 days), high yielding, tolerant to anaerobic germination. Yield of 7 tonnes per hectare",
      name: "FARO 61",
      position: "Rice Variety",
    },
    {
      img: Image5,

      content:
        "Early maturing (95 - 100 days), upland and high-yielding. Yield of 6.2 tonnes per hectare",
      name: "FARO 63",
      position: "Rice Variety",
    },

    {
      img: Image6,

      content:
        "Early maturing (95 - 100 days), upland, high yielding, tolerant to anaerobic germination. Yield of 7 tonnes per hectare",
      name: "FARO 64",
      position: "Rice Variety",
    },
    {
      img: Image7,

      content:
        "Late maturing (125 - 130 days), submergence tolerant, high yielding, long and medium slender grains and moderately tolerant to iron toxicity. Yield of 6.7 tonnes per hectare",
      name: "FARO 66",
      position: "Rice Variety",
    },

    {
      img: Image8,

      content:
        "Late maturing (120 - 130 days),, submergence tolerant, high yielding, long and slender grains and moderately tolerant to iron toxicity. Yield of 6.75 tonnes per hectare",
      name: "FARO 67",
      position: "Rice Variety",
    },

    {
      img: Image9,

      content:
        "early maturing (100 days), high yielding, long slender grains and tolerant to iron toxicity. Yield of 7 tonnes per hectare",
      name: "UPIA 3",
      position: "Rice Variety",
    },

    {
      img: Image10,

      content:
        "Extra-early maturing (80 - 85 days), high grain yield, Striga resistant, drought escaping and tolerant to low soil nitrogen. Yield of 5 - 6 tonnes per hectare",
      name: "IFE HYBRID-6",
      position: "Maize Variety",
    },

    {
      img: Image11,

      content:
        "Medium maturing (105 - 110 days), tolerant to drought and resistant to Striga. Yield of 9.3 tonnes per hectare",
      name: "SAMMAZ 50",
      position: "Maize Variety",
    },

    {
      img: Image12,

      content:
        "Medium maturing (105 - 110 days), shattering and frog eye leaf resistant",
      name: "TGX-1448-2E",
      position: "Soybean Variety",
    },

    {
      img: Image13,

      content:
        "Early maturing (100 - 110 days), low shattering, tolerant to rust, cercospora leaf spot and bacteria postule and adaptable to poor soils. Yield of 2.5 tonnes per hectare",
      name: "TGX-1835-10E",
      position: "Soybean Variety",
    },

    {
      img: Image14,

      content:
        "Medium maturing (110 - 120 days). Low shattering, tolerant to rust, cercospora leaf spot and bacteria postule and adaptable to poor soils. Yield of 2.5 tonnes per hectare",
      name: "TGX-1951-3F",
      position: "Soybean Variety",
    },
  ];

  const [showMorePost, setShowMorePost] = useState(9);

  const loadMore = () => {
    setShowMorePost((prev) => prev + 3);
  };

  return (
    <div className="container testimonial-section" id="testimonial">
      <div className="section_title">
        <h5>Products & Services</h5>
        <span className="line"></span>
      </div>

      <div className="row">
        {data.slice(0, showMorePost).map((item, index) => (
          <Fade right>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={index}>
              <div
                className={index == 0 ? "marked-content-card" : "content-card"}
              >
                <img src={item.img} alt={item.name} />
                <p>
                  <span className="name">{item.name}</span>
                </p>
                <p>{item.position}</p>
                <p>{item.content}</p>
              </div>
            </div>
          </Fade>
        ))}
      </div>

      {showMorePost >= data.length ? null : (
        <Bounce left>
          <span className="load-more-button" onClick={loadMore}>
            Load More
          </span>
        </Bounce>
      )}
    </div>
  );
};

export default Testimonial;
